/**
 * The base border styles for the VoK MUI.
 * You can add new border width, border color or border radius using this file.
 * You can customized the borders value for the entire VoK MUI using thie file.
 */

// VoK MUI Base Styles
import colors from "app/assets/theme-dark/base/colors";

// VoK MUI Helper Functions
import pxToRem from "app/assets/theme-dark/functions/pxToRem";
import rgba from "app/assets/theme-dark/functions/rgba";

const {white} = colors;

const borders = {
    borderColor: rgba(white.main, 0.15),

    borderWidth: {
        0: 0,
        1: pxToRem(1),
        2: pxToRem(2),
        3: pxToRem(3),
        4: pxToRem(4),
        5: pxToRem(5),
    },

    borderRadius: {
        xs: pxToRem(2),
        sm: pxToRem(4),
        md: pxToRem(8),
        lg: pxToRem(12),
        xl: pxToRem(16),
        xxl: pxToRem(24),
        section: pxToRem(160),
    },
};

export default borders;
